import {
  FETCH_ORGANIZATIONS_SUCCESS,
  FETCH_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_SUCCESS,
  UPDATE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_SUCCESS,
} from '../actions/organizationActions'

const initialState = {
  all: [],
  current: null,
}

export const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORGANIZATIONS_SUCCESS:
      return { ...state, all: action.entities }
    case FETCH_ORGANIZATION_SUCCESS:
      return { ...state, current: action.entity }
    case CREATE_ORGANIZATION_SUCCESS:
      return { ...state, all: [...state.all, action.entity] }
    case UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        all: state.all.map((o) => (o.id === action.entity.id ? action.entity : o)),
        current: action.entity,
      }
    case DELETE_ORGANIZATION_SUCCESS:
      return { ...state, all: state.all.filter((o) => o.id !== action.id) }
    default:
      return state
  }
}

export const selectOrganizationIndex = (state = { all: [] }) => state.all || []
export const selectOrganization = (state, id) =>
  (state.all || []).find((o) => o.id === id) || state.current

